import { get } from 'lodash-es';
import { FulfillmentPlanOrderGridStatus } from '../../enums/fulfillmentplan-order-grid-status';
import { ComponentStates, UiRestrictions } from '../../enums/component-states';

const EXTERNAL_FULFILLMENT_TYPE = 'EXTERNAL';
const MANUAL_FULFILLMENT_TYPE = 'MANUAL';

class FulfillmentPlanServiceClass {
  getFulfillmentType(fulfillmentPlan) {
    return get(fulfillmentPlan, 'fulfillmentType');
  }

  isExternal(fulfillmentPlan) {
    const fulfillmentType = this.getFulfillmentType(fulfillmentPlan);
    if (typeof fulfillmentType === 'string') {
      return fulfillmentType.toUpperCase() === EXTERNAL_FULFILLMENT_TYPE;
    }
    return false;
  }

  isManual(fulfillmentPlan) {
    const fulfillmentType = this.getFulfillmentType(fulfillmentPlan);
    if (typeof fulfillmentType === 'string') {
      return fulfillmentType.toUpperCase() === MANUAL_FULFILLMENT_TYPE;
    }
    return false;
  }

  isShipped({ orderGridStatus }) {
    return orderGridStatus === FulfillmentPlanOrderGridStatus.Shipped.name;
  }

  // TODO: This is temporary to not blow scope and fix up OrderDetailsHelperService::getTopLevelOrderMetaData()
  getFulfillmentPlanMetadata(fulfillmentPlan) {
    if (!fulfillmentPlan) {
      return {};
    }
    const { orderGridStatus } = fulfillmentPlan;
    const shouldShowShipmentWidget = this.shouldShowShipmentWidget(fulfillmentPlan);
    const shouldShowCompletedIndicatorStatuses = [
      FulfillmentPlanOrderGridStatus.Shipped.name,
      FulfillmentPlanOrderGridStatus.PendingFulfillment.name,
    ];

    return {
      isCancelled: orderGridStatus === FulfillmentPlanOrderGridStatus.Cancelled.name,
      isAwaitingPayment: orderGridStatus === FulfillmentPlanOrderGridStatus.AwaitingPayment.name,
      shouldShowShipmentWidget,
      shouldShowCompletedIndicator: shouldShowCompletedIndicatorStatuses.includes(orderGridStatus),
    };
  }

  getAllFulfillmentPlansMetadata(fulfillmentPlans) {
    const doNotShowShipmentWidgetStatuses = [
      FulfillmentPlanOrderGridStatus.AwaitingPayment.name,
      FulfillmentPlanOrderGridStatus.Shipped.name,
      FulfillmentPlanOrderGridStatus.Cancelled.name,
    ];

    return {
      isCancelled: fulfillmentPlans.every((fp) => fp.orderGridStatus === FulfillmentPlanOrderGridStatus.Cancelled.name),
      isAwaitingPayment: fulfillmentPlans.every((fp) => fp.orderGridStatus === FulfillmentPlanOrderGridStatus.AwaitingPayment.name),
      shouldShowShipmentWidget: fulfillmentPlans.some((fp) => !doNotShowShipmentWidgetStatuses.includes(fp.orderGridStatus)),
      shouldShowCompletedIndicator: fulfillmentPlans.every((fp) => fp.orderGridStatus === FulfillmentPlanOrderGridStatus.Shipped.name),
    };
  }

  shouldShowShipmentWidget({ orderGridStatus }) {
    const doNotShowShipmentWidgetStatuses = [FulfillmentPlanOrderGridStatus.Shipped.name];

    return !doNotShowShipmentWidgetStatuses.includes(orderGridStatus);
  }

  getExternalShipFromName(fulfillmentPlan, fulfillmentProviders) {
    const sellerFulfillmentProviderId = get(fulfillmentPlan, 'externalFulfillmentConfiguration.sellerFulfillmentProviderId');
    const fulfillmentProviderData = fulfillmentProviders.find(
      (fulfillmentProvider) => fulfillmentProvider.sellerFulfillmentProviderId === sellerFulfillmentProviderId,
    );
    return get(fulfillmentProviderData, 'name');
  }

  hasLabelConfigurationRestriction(restrictions) {
    const hasComponentRestriction = restrictions?.[UiRestrictions.LabelConfiguration]?.componentState === ComponentStates.Hidden;
    return hasComponentRestriction;
  }
}

export const FulfillmentPlanService = new FulfillmentPlanServiceClass();
